import { put } from 'redux-saga/effects'
import { NetworkTimeoutError } from 'utils/request'
import { displayErrorModal } from 'actions/application'
import { HANDLED, SKIP } from './constants'

/**
 * System handler — network timeout.
 *
 * Triggered when a request exceeds the 5-minute hard timeout in `apiRequest`.
 * Shows the ErrorModal with a timeout-specific message that differs from the
 * generic error copy.
 *
 * M4: async-set cleanup is centralised in apiCall.js catch block — this
 * handler no longer dispatches removeFromAsyncSet itself.
 *
 * This is a SYSTEM handler and runs before any user-defined handlers. It
 * cannot be overridden or removed per-request.
 *
 * @param {Error} err        - The caught error.
 * @returns {'handled'|'skip'}
 */
export default function* timeoutHandler(err) {
  if (!(err instanceof NetworkTimeoutError)) {
    return SKIP
  }

  yield put(displayErrorModal(null, [{ timeout: true }]))

  return HANDLED
}
